export const getIconColor = ({ isDisabled, isInvalid, }) => {
    if (isInvalid) {
        return "semantic.icon.error";
    }
    if (isDisabled) {
        return "semantic.icon.disabled";
    }
    return "semantic.icon.info";
};
export const getTextColor = ({ isDisabled }) => {
    if (isDisabled) {
        return "semantic.text.tertiary";
    }
    return "semantic.text.primary";
};
export const getBorderColor = (isInvalid, addBorder) => {
    if (isInvalid) {
        return "semantic.border.error";
    }
    if (addBorder) {
        return "semantic.border.secondary";
    }
    return "transparent";
};
export const Description = ({ size, isDragActive, description, activeDescription, }) => {
    if (size && size === "desktop") {
        return isDragActive ? activeDescription : description;
    }
    return null;
};
//# sourceMappingURL=FileUploader.helpers.js.map